import { RequestDraft } from '../../../context'
import { useRequestDraftProvider } from '../Request.hooks'

function RequestDraftProvider({
  DraftContext = RequestDraft,
  children,
  prefix,
}) {
  const value = useRequestDraftProvider(prefix)

  return <DraftContext value={value}>{children}</DraftContext>
}

export default RequestDraftProvider
